import React from 'react'
import { useGetCurrentUser } from '@/hooks/app'
import { InProgressComponent } from '@/provider/app'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ROUTESPATH } from '@/routes/constant'
import { MSALAUTH } from '@/utils/auth'

export const PrivateTemplate = () => {
    const { data: currentUser, isLoading, isError } = useGetCurrentUser()
    const location = useLocation()

    // A failed fetch (expired/invalid token, transient API error, etc.) is
    // NOT the same as an explicitly deactivated account. The old check
    // (`!dogma_userstatus`) treated "no data because the request errored"
    // the same as "confirmed deactivated", so any token/API hiccup wrongly
    // bounced the user to the Deactivated page instead of logging them out
    // and sending them to login. Log out here as a backstop — the axios
    // interceptors already do this on a 401 response, but this covers any
    // other reason the current-user fetch failed.
    React.useEffect(() => {
        if (isError) MSALAUTH.logOut()
    }, [isError])

    if (isLoading || isError) {
        return <InProgressComponent />
    }

    const isDeactivated = currentUser?.currentUser?.dogma_userstatus === 2

    // Allow access to /deactivated so they can see the message and sign out
    if (isDeactivated && location.pathname !== ROUTESPATH.DEACTIVATED) {
        return <Navigate to={ROUTESPATH.DEACTIVATED} replace />
    }

    return <Outlet />
}
